import browniePointsDefault from './browniePointsDefault'
import growsmart from './growsmart'

// This is now a GS-only repo. Set to true. Do clean-up later
const isGrowsmart = true

const localize = (string, count) => {
  try {
    return isGrowsmart ? growsmart(string, count) : browniePointsDefault(string, count)
  } catch (err) {
    throw new Error(`Localization error for ${string}`)
  }
}

// capitalize
export const c = string => string.charAt(0).toUpperCase() + string.slice(1)

// Uppercase
export const u = string => string.toUpperCase()

// Restrict features to only BP site
export const onlyBp = !isGrowsmart
export const isBp = !isGrowsmart

// Restrict features to only GS site
export const onlyGs = isGrowsmart
export const isGs = isGrowsmart

// All but Gs
export const otherThanGs = !isGrowsmart

export const canDisplayFeature = false

export default localize
